import React, { useEffect } from "react";
import "../styles/About.css";
import portraitImage from "../assets/img/portrait.jpg";
import WOW from "wowjs";
import "animate.css/animate.min.css";

const About = ({ about }) => {
  useEffect(() => {
    new WOW.WOW().init();
  }, []);

  return (
    <section id="about" className="about">
      <div className="about-container">
        <img
          src={portraitImage}
          alt={about.name}
          className="about-image wow animate__animated animate__fadeInLeft"
        />
        <div className="about-content wow animate__animated animate__fadeInRight">
          <h1 className="about-title">{about.name}</h1>
          <p className="about-detail">
            <i className="fas fa-university"></i> {about.university}
          </p>
          <p className="about-detail">
            <i className="fas fa-laptop-code"></i> Major: {about.major} <br />{" "}
            Minor: {about.minor}
          </p>
          <p className="about-detail">
            <i className="fas fa-home"></i> {about.location}
          </p>
          <p className="about-detail">
            <i className="fas fa-phone"></i> {about.phone}
          </p>
          <p className="about-detail">
            <i className="fas fa-envelope"></i> {about.email}
          </p>
          <p className="about-detail">
            <i className="fab fa-github"></i>
            <a href={about.github} target="_blank" rel="noopener noreferrer">
              GitHub
            </a>
          </p>
          <p className="about-detail">
            <i className="fab fa-linkedin"></i>
            <a href={about.linkedin} target="_blank" rel="noopener noreferrer">
              LinkedIn
            </a>
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;
